import type { OpenClock, SessionState } from './types';

export { stageKindLabel } from '@/lib/stage-kind';

// Presentación pura del cronómetro de etapa (so=420, spec §4.1). Los segundos que
// muestra la tarjeta avanzan con el tiempo local transcurrido desde la última lectura
// del servidor; cada lectura re-sincroniza (el valor que cuenta es el del servidor).

export const SESSION_LABELS: Readonly<Record<SessionState, string>> = {
  active: 'Contando',
  paused: 'En pausa',
  idle: 'Sin actividad',
};

const pad = (n: number): string => String(n).padStart(2, '0');

/** `hh:mm:ss`; las horas crecen a más dígitos si hace falta. Negativo o no finito → 0. */
export function formatClock(totalSeconds: number): string {
  const s = Number.isFinite(totalSeconds) ? Math.max(0, Math.floor(totalSeconds)) : 0;
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
}

/**
 * Segundos a mostrar en `now`. El macro suma todo lo transcurrido desde la lectura. El
 * propio solo avanza en sesión activa y hasta un intervalo de latido después del último
 * latido (o de la lectura, si fue posterior): sin interacción deja de avanzar, como el
 * servidor, que cuenta cada tramo hasta su último latido.
 */
export function liveSeconds(
  clock: OpenClock,
  fetchedAt: number,
  lastBeatAt: number | null,
  now: number,
): { macro: number; mine: number; stage: number } {
  const elapsed = Math.max(0, now - fetchedAt);
  let extra = 0;
  if (clock.mine.session === 'active') {
    const anchor = Math.max(lastBeatAt ?? fetchedAt, fetchedAt);
    const until = Math.min(now, anchor + clock.heartbeatIntervalSeconds * 1000);
    extra = Math.max(0, until - fetchedAt);
  }
  return {
    macro: clock.macroSeconds + Math.floor(elapsed / 1000),
    mine: clock.mine.effortSeconds + Math.floor(extra / 1000),
    // El trabajo propio en curso también es trabajo de la etapa.
    stage: clock.stageEffortSeconds + Math.floor(extra / 1000),
  };
}
